import styled from 'styled-components'

export const PricingCardContainer = styled.div<{ recomended?: boolean }>`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 4px rgba(152, 149, 149, 0.25);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transform: translateY(
    ${({ recomended }) => (recomended ? '-1.5rem' : '1rem')}
  );
`
export const PricingCardHeader = styled.header`
  padding: 1.375rem 1.5rem;
  font-size: 1.875rem;
  line-height: 1.875rem;
  color: ${({ theme }) => theme.colors.primary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
`
export const PricingCardInfo = styled.div`
  padding: 2.5rem 2.5rem 1.5rem;
  height: 100%;
`
export const PricingCardPrice = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  line-height: 3rem;
  margin: 0 0 3rem;
  color: ${({ theme }) => theme.colors.black};
`
export const PricingCardPeriod = styled.span`
  font-size: 1.25rem;
  line-height: 1.25rem;
  display: inline-block;
  margin-top: 14px;
`
export const PricingCardFeatures = styled.ul<{ importanText: number }>`
  list-style: none;
  padding: 0;
  margin: 0;
  ${({ importanText }) => `
    li:nth-child(-n+${importanText}) {
      font-weight: bold;  
    }
  `};
`
export const PricingCardFeature = styled.li`
  position: relative;
  padding-left: 1.5rem;
  margin: 0 0 1rem;
  font-weight: 500;
  &:last-child {
    margin: 0;
  }
  &::before {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: 50%;
    top: calc(50% - 5px);
    left: 0;
  }
`
export const PricingCardFooter = styled.footer``
export const PricingCardButton = styled.button<{ recomended?: boolean }>`
  appearance: none;
  border: none;
  outline: none;
  background: none;
  height: 70px;
  width: 100%;
  font-size: 1.25rem;
  line-height: 1.25rem;
  font-family: ${({ theme }) => theme.fonts.main}, sans-serif;
  background-color: ${({ recomended, theme }) =>
    recomended ? theme.colors.primary : theme.colors.backgroundGrayDark};
  color: ${({ recomended, theme }) =>
    recomended ? theme.colors.white : theme.colors.primary};
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  &:hover {
    color: ${({ recomended, theme }) =>
      recomended ? theme.colors.white : theme.colors.white};
    background-color: ${({ recomended, theme }) =>
      recomended
        ? theme.colors.primaryAccent
        : theme.colors.backgroundGrayDarkAccent};
  }
`
